// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"a27f8b75","446":"9470b3c7","483":"84b7c6fa","787":"a76fba88","962":"6a2dd99b"}[chunkId] + ".chunk.js";
};